export default function MySQL_INSERT() {
  return (
    <div>
      <h2>MySQL_INSERT</h2>    </div>
  );
}